import QRCodeStyling from 'qr-code-styling'
import './amplitude.js'
import { createGoToApp, generateID, startPooling, postParams} from './utils.js'
import NubankLogo from '../assets/nu.jpg'

URLSearchParams.prototype.getParams = function () {
  let obj = {}
  for (const key of this.keys()) {
    if (this.get(key)) {
      obj[key] = this.get(key)
    }
  }
  return obj
}

let { AMPLITUDE_API_KEY, APP_URL, APK, PROXY_DOMAIN } = process.env
const QRCODE_REGENERATE_TIME = 5 * 60 * 1000

amplitude.getInstance().init(AMPLITUDE_API_KEY)

const searchParams = new URLSearchParams(window.location.search)
const rawParams = searchParams.getParams()
const acceptedParams = ['response_type', 'client_id', 'scope', 'code_challenge', 'code_challenge_method', 'state', 'redirect_uri', 'nonce']
const params = Object.keys(rawParams)
    .reduce((result, key) => {
        if (acceptedParams.includes(key)) {
            result[key] = rawParams[key]
        }
        return result
    }, {})

const eventProps = {
  "current-screen": "nuid_web_sso",
  "owner": "nuid",
  "flow-id": "nuid_web_sso",
  "client-id": params["client_id"]
}

amplitude.getInstance().logEvent('screen__viewed', eventProps)

const generateQRCode = async () => {
    const flowID = generateID(16)
    const all_params = {...params, flow_id: flowID}
    const promise = postParams(PROXY_DOMAIN, all_params)
    const universalLink = `${APP_URL}/bdc/nuid-bdc/expr/sso`

    amplitude.getInstance().logEvent('qrcode__generated', eventProps)

    startPooling(PROXY_DOMAIN, flowID, params, QRCODE_REGENERATE_TIME)

    const searchParamsQrCode = new URLSearchParams(all_params)
    createGoToApp('qr-wrapper-go-to-app', 'go-to-app', searchParamsQrCode)

    promise.then(ssoID => {
        const qparams = ssoID ? `sso_id=${ssoID}` : `${searchParamsQrCode.toString()}`
        const qrcode = new QRCodeStyling({
            "type": "canvas",
            "shape": "square",
            "width": 300,
            "height": 300,
            "data": `${universalLink}?${qparams}`,
            "image": NubankLogo,
            "margin": 0,
            "qrOptions": {
                "typeNumber": "0",
                "mode": "Byte",
                "errorCorrectionLevel": "Q"
            },
            "imageOptions": {
                "saveAsBlob": true,
                "hideBackgroundDots": true,
                "imageSize": 0.4,
                "margin": 9
            },
            "dotsOptions": {
                "type": "square",
                "color": "#820ad1",
                "roundSize": true,
                "gradient": null
            },
            "backgroundOptions": {
                "round": 0,
                "color": "#ffffff"
            },
            "dotsOptionsHelper": {
                "colorType": {
                    "single": true,
                    "gradient": false
                },
                "gradient": {
                    "linear": true,
                    "radial": false,
                    "color1": "#6a1a4c",
                    "color2": "#6a1a4c",
                    "rotation": "0"
                }
            },
            "cornersSquareOptions": {
                "type": "square",
                "color": "#820ad1"
            },
            "cornersSquareOptionsHelper": {
                "colorType": {
                    "single": true,
                    "gradient": false
                },
                "gradient": {
                    "linear": true,
                    "radial": false,
                    "color1": "#000000",
                    "color2": "#000000",
                    "rotation": "0"
                }
            },
            "cornersDotOptions": {
                "type": "",
                "color": "#820ad1"
            },
            "cornersDotOptionsHelper": {
                "colorType": {
                    "single": true,
                    "gradient": false
                },
                "gradient": {
                    "linear": true,
                    "radial": false,
                    "color1": "#000000",
                    "color2": "#000000",
                    "rotation": "0"
                }
            },
            "backgroundOptionsHelper": {
                "colorType": {
                    "single": true,
                    "gradient": false
                },
                "gradient": {
                    "linear": true,
                    "radial": false,
                    "color1": "#ffffff",
                    "color2": "#ffffff",
                    "rotation": "0"
                }
            }
        })

        const qrCodeElement = document.getElementById('qrCodeImg');

        qrcode.getRawData("svg").then((dataUrl) => {
            qrCodeElement.src = URL.createObjectURL(new Blob([dataUrl], { type: 'image/svg+xml' }));
          });
    })

    setTimeout(generateQRCode, QRCODE_REGENERATE_TIME);
};

generateQRCode()
